<template>
	<div class="m-2">
		<div>
			<div class="col">
				<div class="card card-outline m-2  overflow-hidden">
					<div class="card-header border-transperent d-flex justify-content-between align-items-center">
						<div class="d-flex align-items-center">
							<span style="font-size: 1.3rem;">Status:</span>
							<span v-if="serverErrors.length > 0">
								<i
										class="bi bi-exclamation-triangle-fill text-warning custom-icon ml-2"
										title="Server Connection error"
										@click="showErrorModal = true"
								>
							</i>
							</span>
								<span v-else>
								<i class="bi bi-check-lg text-success"
								title="No Connection Issues detected"
								style="font-size: 2rem"></i>
							</span>
						</div>
						<h3 class="text-center flex-grow-1">Queue Stats</h3>
					</div>
						<b-tabs v-model="activeTab" class="card-bodyp-0 w-100 flex-grow-1 overflow-auto">
							<b-tab title="General">
								<table class="table table-hover table-striped">
									<thead>
									<tr>
										<th></th>
										<th>Active</th>
										<th>Completed</th>
										<th>Delayed</th>
										<th>Failed</th>
										<th>Paused</th>
										<th>Waiting</th>
										<th>Waiting-child</th>
										<th>Total processed last 24h</th>
									</tr>
									</thead>
									<tbody>
										<tr v-for="(queue, index) in filteredGeneralQueues" :key="index" class="p-3" style="width: 100%">
											<th scope="row">{{ queue.label }}</th>
											<td>{{ Number(queue.data.jobCount.active).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queue.data.jobCount.completed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queue.data.jobCount.delayed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queue.data.jobCount.failed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queue.data.jobCount.paused).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queue.data.jobCount.waiting).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queue.data.jobCount['waiting-children']).toLocaleString('de-DE') }}</td>
											<td>{{ Number(totalMetricJobCount(queue)).toLocaleString('de-DE') }}</td>
										</tr>
									</tbody>
								</table>
							</b-tab>
							<b-tab title="GlobalState" class="w-100">
							<table class="table table-hover table-striped">
								<thead>
									<tr>
										<th></th>
										<th>Active</th>
										<th>Completed</th>
										<th>Delayed</th>
										<th>Failed</th>
										<th>Paused</th>
										<th>Waiting</th>
										<th>Waiting-child</th>
										<th>Total processed last 24h</th>
									</tr>
								</thead>
								<tbody>
										<tr
												v-for="(queueStats, queueName) in gsQueues"
												v-bind:key="queueName"
												class="p-3"
												style="width: 100%"
										>
											<th scope="row">{{ formatQueueName(queueName) }}</th>
											<td>{{ Number(queueStats.jobCount.active).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.completed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.delayed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.failed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.paused).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.waiting).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount['waiting-children']).toLocaleString('de-DE') }}</td>
											<td>{{ Number(totalMetricJobCount(queueStats)).toLocaleString('de-DE') }}</td>
										</tr>
								</tbody>
							</table>
						</b-tab>
						<b-tab title="Recomputation" class="w-100">
							<table class="table table-hover table-striped">
								<thead>
									<tr>
										<th>#</th>
										<th>Active</th>
										<th>completed</th>
										<th>Delayed</th>
										<th>Failed</th>
										<th>paused</th>
										<th>waiting</th>
										<th>waiting-child</th>
										<th>processed last 24 hours</th>
									</tr>
								</thead>
								<tbody>
										<tr
												v-for="(queueStats, queueName) in recomputationQueues"
												v-bind:key="queueName"
												class="p-3"
												style="width: 100%"
										>
											<th scope="row">{{ formatQueueName(queueName) }}</th>
											<td>{{ Number(queueStats.jobCount.active).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.completed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.delayed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.failed).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.paused).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount.waiting).toLocaleString('de-DE') }}</td>
											<td>{{ Number(queueStats.jobCount['waiting-children']).toLocaleString('de-DE') }}</td>
											<td>{{ Number(totalMetricJobCount(queueStats)).toLocaleString('de-DE')}}</td>
										</tr>
								</tbody>
							</table>
							</b-tab>
						</b-tabs>
					</div>
				</div>
			</div>
		<b-modal
		v-model="showErrorModal"
		title="Server Connection Issues"
		hide-footer
		size="sm"
		centered
		>
		<p v-for="(err, idx) in serverErrors" :key="idx">
			{{ err.message }}
		</p>
		</b-modal>
		</div>
</template>

<script>
import axios from 'axios';
import { toInteger } from 'lodash';

export default {
	name: 'DashboardView',
	data() {
		return {
			lowestPriceQueue: null,
			priceStarQueue: null,
			recomputationQueues: null,
			gsQueues: null,
			mainEventQueue: null,
			generalQueues: null,
			generalQueueNames: [
				'bolLowestOfferQueue',
				'bolPriceStarRequestQueue',
				'cdiscountQueueStats',
				'mainEventQueue',
				'rakutenQueue',
				'requestQueue',
				'onbuyUkQueue',
				'onbuyDeQueue'

			],
			refreshRate: 30000, //mili seconds - 60000 = 1 min
			activeTab: 0,
			requestInProgress: true,
			queueMetadata: {},
			showErrorModal: false,
			serverErrors: [],
		};
	},
	created() {
		this.fetchQueueStats();
	},
	mounted() {
		setInterval(() => {
			this.fetchQueueStats();
			console.log('refreshed');
		}, this.refreshRate);
	},
	computed: {
		filteredGeneralQueues() {
			if (!this.generalQueues || Object.keys(this.generalQueues).length === 0) return [];

			return Object.entries(this.generalQueues).map(([key, data]) => {
				let label = key
						.replace(/Stats$/, '')
						.replace(/([a-z])([A-Z])/g, '$1 $2')
						.replace(/^./, str => str.toUpperCase());

				return { label, data };
			});
		}
	},
	methods: {
		fetchQueueStats() {
			// console.log("queueStats")
			axios
					.get(`/ngps/queue_stats`)
					.then((res) => {

						this.generalQueues = {};
						this.queueMetadata = res.data.meta;
						this.checkQueueConnectionStatus()
						for (const [queue, queueStats] of Object.entries(res.data.queueData)) {
							if (
									this.generalQueueNames.some(name => queue.startsWith(name))
							) {
								console.log(queue);
								this.calcMetricsJobCount(queueStats);
								// console.log(queueStats);
								this.generalQueues[queue] = queueStats;
							}
						}

						this.recomputationQueues = {};
						for (const [queue, queueStats] of Object.entries(res.data.queueData)) {
							if (queue.startsWith('recomputationQueueStats')) {
								// console.log(queue);
								this.calcMetricsJobCount(queueStats);
								// console.log(queueStats);
								this.recomputationQueues[queue] = queueStats;
							}
						}

						this.gsQueues = {};
						for (const [queue, queueStats] of Object.entries(res.data.queueData)) {
							if (queue.startsWith('gsStats')) {
								// console.log(queue);
								this.calcMetricsJobCount(queueStats);
								// console.log(queueStats);
								this.gsQueues[queue] = queueStats;
							}
						}
						this.requestInProgress = false;
					})
					.catch((err) => {
						console.log('queueStats err');
						console.log(err);
						this.requestInProgress = false
					});
		},
		//sums up all the metric Job Count for both job types
		calcMetricsJobCount(queue) {
			queue.completedJobs.metricJobCount = 0;
			queue.failedJobs.metricJobCount = 0;
			if (queue.completedJobs.count !== 0) {
				queue.completedJobs.data.forEach((element) => {
					queue.completedJobs.metricJobCount += toInteger(element);
				});
			}
			if (queue.failedJobs.count !== 0) {
				queue.failedJobs.data.forEach((element) => {
					queue.failedJobs.metricJobCount += toInteger(element);
				});
			}
		},
		totalMetricJobCount(queue) {
			if(!queue) return null;
			if(queue.completedJobs?.metricJobCount && queue.failedJobs?.metricJobCount){

				return (
						(queue.completedJobs?.metricJobCount ?? 0) +
						(queue.failedJobs?.metricJobCount ?? 0)
				);
			} else if (queue?.data?.completedJobs?.metricJobCount && queue?.data?.failedJobs?.metricJobCount){
				return (
						(queue.data.completedJobs?.metricJobCount ?? 0) +
						(queue.data.failedJobs?.metricJobCount ?? 0)
				);
			} else {
				return 0;
			}
		},
		//calculates the percentage of a job type in relation to total metric jobcount
		//if any metricJobCount is 0, it returns 0 because of dividing 0
		calcMetricJobCountPercentage(queue, isCompletedJobs) {
		return 0;
			if (
					queue.completedJobs.metricJobCount === 0 &&
					queue.failedJobs.metricJobCount === 0
			)
				return 0;
			if (isCompletedJobs) {
				if (queue.completedJobs.metricJobCount === 0) return 0;
				return Math.round(
						(queue.completedJobs.metricJobCount /
								this.totalMetricJobCount(queue)) *
						100,
				);
			} else {
				if (queue.failedJobs.metricJobCount === 0) return 0;
				return Math.round(
						(queue.failedJobs.metricJobCount / this.totalMetricJobCount(queue)) *
						100,
				);
			}
		},
		checkQueueConnectionStatus(){
		this.serverErrors = [];
			this.serverErrors = Object.entries(this.queueMetadata)
					.filter(([key, value]) => value.status === "failed")
					.map(([key, value]) => ({ message: this.formatConnectionErrors(value.message, key)  }));
		},
		translateProdName(prodName){
			switch (prodName) {
				case 'prod-1':
					return 'Amazon EU';
				case 'prod-3':
					return 'Amazon Non EU';
				case 'prod-4':
					return 'Non Amazon';
				default:
					return prodName;
			}
		},
		formatConnectionErrors(message, ngpsServer){
			if(message.includes("timeout")){
				return message + " for " + this.translateProdName(ngpsServer) + " Ngps Server."
			} else {
				return "An Error occurred for " + this.translateProdName(ngpsServer) + " Ngps Server: " + message
			}
		},
		formatQueueName(queueName){
			const cutName = queueName.substring(queueName.length-5, queueName.length);
			return (cutName.slice(0, 3) + '-' + cutName.slice(3)).toUpperCase();

		}
	},
};
</script>
<style scoped>
.custom-icon {
	font-size: 2rem;
	color: yellow;
	-webkit-text-stroke: 1px black;
	cursor: pointer;
}
</style>